<template>
    <activities :reference-id="$route.params.slug" reference-type="proposal" />
</template>

<script>
    import Activities from '../../../components/Activities'

    export default {
        components: {
            Activities
        }
    }
</script>
